import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import {
  BaseBean,
  MasterAttributeBean,
  NodeData,
  RestReportBean,
} from "../ds/client_ds.js";
import {
  DepositBean,
  DepositLineBean,
  DepositPrintOutRequest,
  DepositSearchCriteria,
  PageListBean,
  RestDepositBeanRequest,
  RestEntityUnLockRequest,
  RestReadRequest,
  UnDepositedAccountReceivableDetailCriteriaBean,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  CancelIcon,
  DropDwnDown,
  DropDwnUp,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { DepositLookupHandler } from "../lookup/DepositLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PopupARModule, PopupCustomerModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { ReportService } from "../services/ReportService.js";
import { DepositToolBar } from "../toolBar/DepositToolbar.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
import {
  ApproveIcon,

  UnApproveIcon,
} from "../gui_components/Icons.js";
import { History,AlignStartVertical} from "lucide-react";
class DepositEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.bankCodeRef = React.createRef();
    this.paymentTypesRef = React.createRef();
    this.state = {};
  }
  depositColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(false, false, true, null, this.onSelectedChange, null)
        .setDisabled(this.props.isDisableFields)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AR##", "arNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.lnkARModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("AR Date", "arDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Posting Date", "postingDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.lnkCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer Name", "customerName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Payment Type#", "paymentTypeName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Pay.Doc Number", "paymentDocumentNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Pay.Doc Date", "paymentDocumentDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Tender Amount", "totalTenderAmount", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Deposit Amount", "depositAmount", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isActive", 0, false, "5", null, false, null)
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange
        )
        .setDisabled(this.props.isDisableFields)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "AR#",
        "arNumber",
        0,
        true,
        this.lnkARModule,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "AR Date",
        "arDate",
        // true,
        0,
        false,
        // this.handleLineNumberClick,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Posting Date",
        "postingDate",
        0,
        false,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer",
        "customerCode",
        0,
        true,
        this.lnkCustomerModule,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer Name",
        "customerName",
        0,
        false,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Payment Type",

        "paymentTypeName",
        0,
        false,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Pay.Doc Number",
        "paymentDocumentNumber",
        0,
        false,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Pay.Doc Date",
        "paymentDocumentDate",
        0,
        false,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Tender Amount",
        "totalTenderAmount",
        1,
        false,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Deposit Amount",
        "depositAmount",
        1,
        false,
        false,
        null,
        "3px", //min-width
        "3%" //max-width
      )
    );
    return columnList;
  };
  openPaymentTypeForm = (e) => {
    if (e.detail === 1) this.props.openPaymentTypeForm();
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  fetchClick = (e) => {
    if (e.detail <= 1) this.props.fetchClick();
  };
  selectAll = (e) => {
    if (e.detail <= 1) this.props.selectAll();
  };
  unSelectAll = (e) => {
    if (e.detail <= 1) this.props.unSelectAll();
  };
  calculateDepositAmount = (depositLine) => {
    this.props.calculateDepositAmount(depositLine);
  };
  onSelectedChange = (evt, depositLine) => {
    this.props.onSelectedChange(evt, depositLine);
  };
  lnkCustomerModule = (e, code, rowData) => {
    this.props.lnkCustomerModule(code);
  };
  lnkARModule = (e, code, rowData) => {
    this.props.lnkARModule(code);
  };
  bankOnChange = (e) => {
    this.props.bankOnChange(e);
  };
  bankEnterKeyEvent = (e) => {
    this.props.bankEnterKeyEvent(e);
  };
  /**
   *
   * @param {boolean} showAutoCompleteList
   * return boolean
   */
  displayBankAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayBankAutoCompleteList(showAutoCompleteList);
  };
  render() {
    let depositData = this.props.depositData;
    let lines = this.props.depositLineList;
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
          width: "100%",
        },
      },
      table: {
        style: {
          minHeight: "320px",
          maxHeight: "320px",
          overflowY: "auto",
          width: "100%",
        },
      },
    };
    const textAreaStyle = {
      height: "8em",
      width: "20em",
      resize: "none",
      padding: "3px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let overAllPaymentTypes = this.props.overAllPaymentTypes;
    return (
      <div>
        <div className="header_div">
          <div className="div_inline ">
            <div className="div_75_no_overflow_no_height">
              <Row>
                <Col className="align-items-left">
                  <FormLabel className="label_head">Deposit Details</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Deposit Date</FormLabel>
                </Col>
                <Col sm="3">
                  <DatePickerComponent
                    onChange={this.onChange}
                    name="depositDate"
                    value={depositData.depositDate}
                    disabled={this.props.isDisableFields}
                    isMandatory={true}
                  ></DatePickerComponent>
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Start Date</FormLabel>
                </Col>
                <Col className="align-items-left" sm="3">
                  <DatePickerComponent
                    onChange={this.onChange}
                    name="postStartDate"
                    value={depositData.postStartDate}
                    disabled={this.props.isDisableFields}
                  ></DatePickerComponent>
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Stop Date</FormLabel>
                </Col>
                <Col sm="3">
                  <DatePickerComponent
                    onChange={this.onChange}
                    name="postStopDate"
                    value={depositData.postStopDate}
                    disabled={this.props.isDisableFields}
                  ></DatePickerComponent>
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Bank Code</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.bankOnChange}
                    placeholder="bankCode"
                    name="bankCode"
                    value={depositData.bankCode}
                    lookupRequired={true}
                    lookupHandler={this.props.bankLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.bankEnterKeyEvent}
                    autoCompleteListData={
                      this.props.bankPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayBankAutoCompleteList}
                    showAutoCompleteList={this.props.isShowAutoCompleteBankList}
                    disabled={this.props.isDisableFields}
                    isMandatory={true}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Payment Types</FormLabel>{" "}
                </Col>
                <Col className="align-items-left" sm="">
                  <InputTextbox
                    name="overAllPaymentTypes"
                    onChange={this.onChange}
                    value={overAllPaymentTypes}
                    readOnly={true}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <Button
                    className="addIcon"
                    size="sm"
                    onClick={(e) => this.openPaymentTypeForm(e)}
                    disabled={this.props.isDisableFields}
                  >
                    <AddIcon />
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="1">
                  <FormLabel>TotalAmt</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.onChange}
                    name="depositTotalAmount"
                    placeholder="depositTotalAmount"
                    value={depositData.depositTotalAmount}
                    disabled={true}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  <FormLabel>Currency</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.onChange}
                    name="currencyCode"
                    placeholder="currencyCode"
                    value={depositData.currencyCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Bank Ref#</FormLabel>{" "}
                </Col>
                <Col sm="3">
                  <InputTextbox
                    onChange={this.onChange}
                    name="depositBankReferenceNumber"
                    placeholder="BankReferenceNumber"
                    value={depositData.depositBankReferenceNumber}
                    disabled={this.props.isDisableFields}
                    isMandatory={true}
                  />
                </Col>
              </Row>
            </div>
            <div className="div_25_no_overflow_no_height ">
              <Row>
                <Col className="align-items-left">
                  <FormLabel>Remarks</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left">
                  {" "}
                  <textarea
                    style={textAreaStyle}
                    name="remarks"
                    type="text"
                    onChange={this.onChange}
                    value={depositData.remarks}
                    disabled={this.props.isDisableFields}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <div className="">
            <Row>
              {/* <Col className="align-items-left" sm="2">
                <FormLabel>Deposit Lines</FormLabel>
              </Col> */}
              <Col className="deposit_Module_Buttons">
                <Button
                  className="enterFocus"
                  id="fabric_Add_Button"
                  onClick={(e) => this.fetchClick(e)}
                  disabled={this.props.isDisableFields}
                >
                  Fetch
                </Button>
                <Button
                  className="enterFocus"
                  id="fabric_Add_Button"
                  onClick={(e) => this.selectAll(e)}
                  disabled={this.props.isDisableFields}
                >
                  Select All
                </Button>
                <Button
                  className="enterFocus"
                  id="fabric_Add_Button"
                  onClick={(e) => this.unSelectAll(e)}
                  disabled={this.props.isDisableFields}
                >
                  UnSelect All
                </Button>
              </Col>
            </Row>
            {/* <EditableDataGrid
              customStyles={dataTableStyles}
              columnsList={this.columnDefinitions()}
              dataList={lines}
            /> */}
            <div className="div_Custom_1">
              <CustomTable
                columns={this.depositColumns()}
                data={lines}
                label={"Deposit Lines"}
                enableVritualizer={true}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class DepositListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      criteria: new DepositSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  listFormOnChange = (e) => {
    this.props.listFormOnChange(e);
  };
  resetDeposit = (e) => {
    if (e.detail === 1) this.props.resetDeposit();
  };
  filterDeposit = (e) => {
    if (e.detail === 1) this.props.filterDeposit();
  };
  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };
  editDeposit = (e, val) => {
    if (e.detail === 1) this.props.editDeposit(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterDeposit();
    }
  };
  render() {
    let deposit_list = this.props.deposit_list;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="depositNumberContains"
                type="text"
                value={criteria.depositNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterDeposit(e)}>Filter</Button>
              <Button onClick={(e) => this.resetDeposit(e)}>Reset</Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) => this.handleSortingChange(e, "depositNumber")}
                >
                  Deposit#
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "bankCode")}>
                  BankCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "paymentTypesName")
                  }
                >
                  PaymentType
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "status")}>
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "status" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {deposit_list != null ? (
              <tbody>
                {deposit_list.map((ln, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editDeposit(e, ln.depositNumber)}
                      >
                        {ln.depositNumber}
                      </Button>
                    </td>
                    <td>{ln.bankCode}</td>
                    <td>{ln.paymentTypesName}</td>
                    <td>{ModuleUtils.getDepositStatusCaption(ln.status)}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {deposit_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class DepositList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      paymentList: "",
      pageTitle: "DEPOSIT",
      deposit_list: new Array(),
      companyCode: "",
      pageList: new PageListBean(),
      isLoading: false,
      criteria: new DepositSearchCriteria(),
      depositData: new DepositBean(),
      linesData: [],
      depositLinesData: new DepositLineBean(),
      depositLineDatas: [],
      currentPageNumber: 0,
      totalCount: 0,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowReverseButton: false,
      isShowPostButton: false,
      error_list: [],
      isAdvanceSearch: false,
      selectedPayment: [],
      selectPaymentCode: [],
      isSpecialViewMode: false,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      isResetView: true,
      isFocusLookup: true,
      isFocus: false,
      amount: 0,
      isResetModule: false,
      paymentConvert: [],
      selectedPaymentTypes: new Array(),
      banks: [],
      paymentTypes: [],
      order: "asc",
      sortField: "",
      statusTracks: [],
      moduleOrderStatus: "",
      isShowNodes: false,
      isListFormOpen: false,
      isEntryFormOpen: false,
      isHistoryFormOpened: false,
      nodeList: [],
      selectedNodeKey: "headerView",
      isShowPaymentTypePopup: false,
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      availablePayments: [],
      selectedPayments: [],
      overAllPaymentTypes: "",
      isShowAlertLvl3: false,
      depositLineList: [],
      selectedDepositList: new Array(),
      isShowExcelButton: false,
      isShowCustomerModule: false,
      isShowARModule: false,
      moduleForPopup: [],
      isDisableFields: false,
      isReseted: false,
      isViewMode: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.moduleCaption = "DEPOSIT";
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let banks = this.state.banks;
    banks = attribute_cache.bankAccounts;
    let bank_temp=[];
    if (!isEmptyArray(banks))
      banks.map((bank) => {
        bank_temp.push(bank);
         this.state.banks=ModuleUtils.isActiveAttribute(bank_temp);
      });
    ModuleUtils.getDepositStatusList();
    this.initPaymentTypes();
    this.initLookupHandlers();
    this.state.criteria = new DepositSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      // this.unlockDeposit(this.props.code);
      this.code = this.props.code;
      this.editDeposit(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisableFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
  }
  initLookupHandlers = () => {
    let depositLookupHandler = new DepositLookupHandler(
      this.companyCode,
      "Deposit"
    );
    this.setState({
      depositLookupHandler: depositLookupHandler,
    });
    let bankLookupHandler = new GenericAttributeLookupHandler(
      this.state.banks,
      "Bank"
    );
    this.setState({ bankLookupHandler: bankLookupHandler });
  };
  initPaymentTypes = () => {
    let payment = [];
    let check = new MasterAttributeBean();
    check.code = "CHECK";
    check.description = "1";
    payment.push(check);
    let creditCard = new MasterAttributeBean();
    creditCard.code = "CREDIT CARD";
    creditCard.description = "3";
    payment.push(creditCard);
    let debitCard = new MasterAttributeBean();
    debitCard.code = "DEBIT CARD";
    debitCard.description = "4";
    payment.push(debitCard);
    let cash = new MasterAttributeBean();
    cash.code = "CASH";
    cash.description = "5";
    payment.push(cash);
    let wireTransfer = new MasterAttributeBean();
    wireTransfer.code = "WIRETRANSFER";
    wireTransfer.description = "8";
    payment.push(wireTransfer);
    this.setState({
      paymentTypes: payment,
      availablePayments: payment,
    });
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    let criteria = new DepositSearchCriteria();
    criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.loadDepositPage();
  };
  loadDepositPage = () => {
    let requestInput = new RestDepositBeanRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.DepositView_IsAccessible()) {
      AccountPayableService.getDepositPageList(
        requestInput,
        this.loadDepositResponse,
        this.loadDepositError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadDepositResponse = (response) => {
    let depositListData = response.data.depositPageList.deposits;
    let paymentConvert = [];
    for (let paymentList of depositListData) {
      let checklist = paymentList.paymentTypes;
      const answer_array = checklist.split(",");
      let newArray = [];
      for (let list of answer_array) {
        if (list == 1) {
          let check = new BaseBean();
          check.code = "CHECK";
          check.description = "CHECK";
          newArray.push(check);
        }
        if (list == 3) {
          let creditCard = new BaseBean();
          creditCard.code = "CREDITCARD";
          creditCard.description = "CREDITCARD";
          newArray.push(creditCard);
        }
        if (list == 4) {
          let debitCard = new BaseBean();
          debitCard.code = "DEBITCARD";
          debitCard.description = "DEBITCARD";
          newArray.push(debitCard);
        }
        if (list == 5) {
          let cash = new BaseBean();
          cash.code = "CASH";
          cash.description = "CASH";
          newArray.push(cash);
        }
        if (list == 8) {
          let wire = new BaseBean();
          wire.code = "WIRETRANSFER";
          wire.description = "WIRETRANSFER";
          newArray.push(wire);
        }
      }
      let paymentType = "";
      let convertor = "";
      let isFirst = true;
      newArray.map((receiptLine) => {
        if (isFirst) {
          paymentType = receiptLine.description;
          convertor = receiptLine.code;
          isFirst = false;
        } else {
          paymentType = paymentType + "," + receiptLine.description;
          convertor = convertor + "," + receiptLine.code;
        }
      });
      paymentList.paymentTypesName = paymentType;
      paymentConvert.push(paymentList);
    }
    depositListData = paymentConvert;
    let pageList = this.state.pageList;
    pageList.totalCount = response.data.depositPageList.totalCount;
    pageList.currentPage = response.data.depositPageList.currentPage;
    this.setState({
      isLoading: false,
      deposit_list: depositListData,
    });
  };
  loadDepositError = (error) => {
    ShowError("Error : ", error);
  };
  addNewEntry = () => {
    let depositeBean = new DepositBean();
    depositeBean.companyCode = this.companyCode;
    depositeBean.status = LogicConstants.DEPOSIT_OPEN_STATUS;
    depositeBean.currencyCode = "USD";
    depositeBean.depositDate = new Date();
    depositeBean.depositTotalAmount = 0;
    let depositeLineBean = new DepositLineBean();
    if (!isEmptyString(this.state.moduleKeyCode)) {
      depositeBean.depositNumber = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else depositeBean.depositNumber = NEW_ENTRY;
    let pageTitle = this.moduleCaption + " - NEW";
    this.setState({
      depositData: depositeBean,
      depositLinesData: depositeLineBean,
      pageTitle: pageTitle,
      statusTracks: new Array(),
    });
    this.state.depositData = depositeBean;
    this.openEntryForm();
  };
  onChange = (e) => {
    let temp_depositData = this.state.depositData;
    temp_depositData[e.target.name] = e.target.value;
    if (e.target.name == "paymentTypes") {
      temp_depositData["paymentTypes"] = e.target.value;
      temp_depositData.depositLines.push(temp_depositData.paymentTypes);
      temp_depositData[e.target.name] = e.target.value;
    }
    this.setState({
      linesData: temp_depositData,
      depositData: temp_depositData,
    });
  };
  calculateDepositAmount = (selectedDepositList) => {
    let depositData = this.state.depositData;
    let amount = 0;
    selectedDepositList.map((list) => {
      amount += list.depositAmount;
    });
    depositData.depositTotalAmount = parseFloat(amount).toFixed(2);
    this.setState({
      depositData: depositData,
    });
  };
  handleApproveResponse = (response) => {
    let success = false;
    let mainResponseSuccess = false;
    let additionalResponseSuccess = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.mainOperationResponse != null) {
      if (response.mainOperationResponse.errors != null) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        mainResponseSuccess = false;
      }
      if (response.mainOperationResponse.infos != null) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
        );
        mainResponseSuccess = true;
        let successMsg = [];
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
        });
      }
    }
    if (response.additionalOperationResponse != null) {
      if (response.additionalOperationResponse.errors != null) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        additionalResponseSuccess = false;
      }
      if (response.additionalOperationResponse.infos != null) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
        );
        additionalResponseSuccess = true;
        let successMsg = [];
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
        });
      }
    }
    success = mainResponseSuccess && additionalResponseSuccess;
    return success;
  };
  save = () => {
    let depositData = this.state.depositData;
    depositData.depositLines = this.state.selectedDepositList;
    let request = new RestDepositBeanRequest();
    request.deposit = depositData;
    request.isLockRequired = false;
    if (
      SecurityAccessManager.DepositCreate_IsAccessible() ||
      SecurityAccessManager.DepositApproval_IsAccessible()
    ) {
      AccountPayableService.createAndApproveDeposit(
        request,
        this.saveDepositResponse,
        this.saveDepositError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  saveDepositResponse = (response) => {
    let isSuccess = this.handleApproveResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.mainOperationResponse) &&
      !isEmpty(response.data.mainOperationResponse.depositBean) &&
      isSuccess == true
    ) {
      let responseData = response.data.mainOperationResponse;
      let depositData = response.data.mainOperationResponse.depositBean;
      this.setState({
        depositData: depositData,
      });
      // this.unlockDeposit(depositData.depositNumber);
      // this.editDeposit(depositData.depositNumber);

      if (!this.isLocked) {
        this.editDeposit(depositData.depositNumber);
      } else {
        this.code = depositData.depositNumber;
        this.unlockDeposit(depositData.depositNumber);
      }
    }
  };
  saveDepositError = (error) => {
    ShowError("Error", error);
  };
  editDeposit = (depositCode) => {
    this.setState({
      isLoading: true,
    });
    if (isEmptyString(depositCode)) return;
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = depositCode;
    let isLockRequired = NEW_ENTRY === depositCode ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.DepositMaintenance_IsAccessible()) {
      AccountPayableService.initDepositModule(
        readrestInput,
        this.editDepositResponse,
        this.editDepositError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editDepositResponse = (response) => {
    if (response.data != null) {
      let errMsg = "";
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.errors != null) {
          response.data.mainOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.additionalOperationResponse != null) {
        if (response.data.additionalOperationResponse.errors != null) {
          response.data.additionalOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (
          errMsg !=
          " Deposit Number [" +
            this.state.moduleKeyCode +
            "] Not Read Successfully"
        ) {
          this.showErrorMessage(response.data.mainOperationResponse);
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.depositBean != null) {
          const depositData = response.data.mainOperationResponse.depositBean;
          let statusTracks = [];
          statusTracks = depositData.statusTracks;
          let moduleKeyCode = depositData.depositNumber;
          let pageTitle = this.moduleCaption + " - EDIT";
          let depositLinesData = [];
          depositLinesData = depositData.depositLines;
          depositLinesData.map((ln) => {
            ln.isActive = true;
            if (ln.paymentType == 1) {
              ln.paymentTypeName = "CHECK";
            }
            if (ln.paymentType == 3) {
              ln.paymentTypeName = "CREDIT CARD";
            }
            if (ln.paymentType == 4) {
              ln.paymentTypeName = "DEBIT CARD";
            }
            if (ln.paymentType == 5) {
              ln.paymentTypeName = "CASH";
            }
            if (ln.paymentType == 8) {
              ln.paymentTypeName = "WIRETRANSFER";
            }
          });
          let paymentType = "";
          let payment_Types = [];
          let paymentTypes = [];
          paymentType = depositData.paymentTypes;
          if (!isEmptyString(paymentType)) {
            payment_Types = paymentType.split(",");
          }
          payment_Types.map((type) => {
            if (type == 1) {
              paymentTypes.push("CHECK");
            }
            if (type == 3) {
              paymentTypes.push("CREDIT CARD");
            }
            if (type == 4) {
              paymentTypes.push("DEBIT CARD");
            }
            if (type == 5) {
              paymentTypes.push("CASH");
            }
            if (type == 8) {
              paymentTypes.push("WIRETRANSFER");
            }
          });
          let overAllPaymentTypes = "";
          if (!isEmptyArray(paymentTypes)) {
            overAllPaymentTypes = paymentTypes.toString();
          }
          this.setState({
            depositData: depositData,
            overAllPaymentTypes: overAllPaymentTypes,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            isLoading: false,
            depositLineList: depositLinesData,
            statusTracks: statusTracks,
          });
          this.state.depositData = depositData;
          this.isLocked = true;
          this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
    }
    this.setState({
      isLoading: false,
    });
  };
  editDepositError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :" + error);
  };
  resetView = () => {
    let depositData = this.state.depositData;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockDeposit(depositData.depositNumber);
    } else {
      this.isLocked = false;
    }

    this.setState({
      depositData: new DepositBean(),
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
      availablePayments: [],
      selectedPayments: [],
      isShowAlertLvl3: false,
      depositLineList: [],
      selectedDepositList: [],
      overAllPaymentTypes: "",
      isDisableFields: false,
      statusTracks: new Array(),
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.addNewEntry();
    this.calculateDepositAmount(new Array());
    this.initPaymentTypes();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editDeposit(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  fetchClick = () => {
    let payment_Types = this.state.depositData.paymentTypes;
    if (!isEmptyString(payment_Types)) {
      this.setState({
        isLoading: true,
        loadingText: "Fetching ..",
      });
      let readrestInput = new UnDepositedAccountReceivableDetailCriteriaBean();
      let startPostDate = this.state.depositData.postStartDate;
      let stopPostDate = this.state.depositData.postStopDate;
      readrestInput.companyCode = this.companyCode;
      readrestInput.paymentTypes = this.state.depositData.paymentTypes;
      readrestInput.startPostDate = startPostDate;
      readrestInput.stopPostDate = stopPostDate;
      this.setState({
        isLoading: true,
      });
      if (SecurityAccessManager.DepositMaintenance_IsAccessible()) {
        AccountPayableService.getAccountReceivableDetailsForDeposit(
          readrestInput,
          this.fetchClickResponse,
          this.fetchClickError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      let errMsg = "Payment Type Required";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  fetchClickResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });

    let fetchResponse = new Array();
    if (
      response.data != null &&
      response.data.depositBean != null &&
      response.data.depositBean.depositLines != null
    ) {
      fetchResponse = response.data.depositBean.depositLines;
      let paymentList = [];
      for (let list of fetchResponse) {
        if (list.paymentType == 1) {
          list.paymentTypeName = "CHECK";
        } else if (list.paymentType == 3) {
          list.paymentTypeName = "CREDITCARD";
        } else if (list.paymentType == 4) {
          list.paymentTypeName = "DEBITCARD";
        } else if (list.paymentType == 5) {
          list.paymentTypeName = "CASH";
        } else if (list.paymentType == 8) {
          list.paymentTypeName = "WIRETRANSFER";
        }
        paymentList.push(list);
      }
      this.setState({
        depositLineList: fetchResponse,
        depositLinesData: fetchResponse,
        selectedDepositList: new Array(),
        isLoading: false,
      });
    }
    this.calculateDepositAmount(new Array());
    this.setState({
      isLoading: false,
    });
  };
  fetchClickError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  generateExcel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Excel ..",
    });
    this.downloadReport(2, this.state.depositData.depositNumber);
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF ..",
    });
    this.downloadReport(1, this.state.depositData.depositNumber);
  };
  downloadReportResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  downloadReportResponseForExcel = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
                window.open(downloadAddress, "_blank");
      }
    }
  };
  downloadReportError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  downloadReport = (reportType, code) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new DepositPrintOutRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.depositNumber = code;
    requestInput.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.DepositPDFReport_IsAccessible()) {
        ReportService.generateDepositPrintOutReport(
          requestInput,
          this.downloadReportResponse,
          this.downloadReportError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (SecurityAccessManager.DepositExcelReport_IsAccessible()) {
        ReportService.generateDepositPrintOutReport(
          requestInput,
          this.downloadReportResponseForExcel,
          this.downloadReportError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  openEntryForm = () => {
    this.clearError();
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isShowApproveButton: false,
      isShowUnApproveButton: false,
      isShowGenerateInvoiceButton: false,
      isShowCancelButton: false,
      isShowModuleSearchContainer: true,
      isResetCustomerDynamicAutoComplete: false,
      isShowNodes: true,
      isResetView: true,
      isShowAutoCompleteBankList: false,
      bankPageListForAutoCompleteList: new Array(),
    });
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getDepositStatusCaption(
      this.state.depositData.status
    );
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    this.initModuleButtons();
  };
  initModuleButtons() {
    let depositData = this.state.depositData;
    if (depositData.status == "O") {
      this.setState({
        isShowSaveButton: true,
        isShowPDFReportButton: false,
        isShowExcelButton: false,
        isDisableFields: false,
      });
    } else if (depositData.status == "A") {
      this.setState({
        isShowSaveButton: false,
        isShowPDFReportButton: true,
        isShowExcelButton: true,
        isDisableFields: true,
      });
    }

    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        isDisableFields: true,
        disabled: true,
        pageTitle: pageTitle,
      });
    }
  }
  closeEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowBackButton: false,
      sShowCancelButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      errorList: [],
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      depositLineDatas: [],
      depositLineList: [],
      selectedDepositList: [],
      overAllPaymentTypes: "",
      isDisableFields: false,
      isViewMode: false,
      isSpecialViewMode: false,
      selectedPayments: [],
    });
    this.initPaymentTypes();
  };
  getModuleListView = () => {
    let depositData = this.state.depositData;
    if (depositData.depositNumber === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadPage(1);
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockDeposit(depositData.depositNumber);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadPage(1);
    }
  };
  moduleExit = () => {
    let depositData = this.state.depositData;
    if (depositData.depositNumber === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockDeposit(depositData.depositNumber);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  selectAll = (e) => {
    let depositLineList = this.state.depositLineList;
    depositLineList.map((ln) => {
      ln.isActive = true;
    });
    this.setState({ selectedDepositList: depositLineList });
    this.calculateDepositAmount(depositLineList);
  };
  unSelectAll = (e) => {
    let selectedDepositList = this.state.selectedDepositList;
    selectedDepositList.map((ln) => {
      ln.isActive = false;
    });
    this.setState({ selectedDepositList: [] });
    this.calculateDepositAmount(new Array());
  };
  onSelectedChange = (e, rowData) => {
    rowData.isActive = e.target.value;
    const selectedDepositList = this.state.selectedDepositList;
    if (rowData.isActive == true) {
      selectedDepositList.push(rowData);
      this.setState({ selectedDepositList: selectedDepositList });
    } else {
      var index = selectedDepositList.indexOf(rowData);
      if (index > -1) {
        selectedDepositList.splice(index, 1);
      }
    }
    this.calculateDepositAmount(selectedDepositList);
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isListFormOpen: false,
      isEntryFormOpen: false,
      isHistoryFormOpened: false,
    });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let depositData = this.state.depositData;
    let headerObject = this.getEmptyView();
    let historyObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject, <AlignStartVertical size={16} />);
    let historyNode = new NodeData("historyView", "History", historyObject, <History size={16} />);
    nodeList["headerView"] = headerNode;
    if (depositData.isFetched == true) {
      nodeList["historyView"] = historyNode;
    }
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setHeaderView();
    } else if (selectedNode == "historyView") {
      this.setHistoryView();
    }
  };
  setHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isListFormOpen: false,
      isEntryFormOpen: true,
      isHistoryFormOpened: false,
    });
  };
  setHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isListFormOpen: false,
      isEntryFormOpen: false,
      isHistoryFormOpened: true,
    });
  };
  getHistoryView() {
    return (
      <DepositHistoryDetailsForm
        {...this.state}
        handleSortingStatusHistoryChange={this.handleSortingStatusHistoryChange}
      />
    );
  }
  bankOnChange = (e) => {
    let bankCode = e.target.value;
    this.state.isShowAutoCompleteBankList = true;
    let tempData = this.state.depositData;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    if (isEmpty(bankCode)) {
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      let tempData = this.state.depositData;
      tempData.bankCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        depositData: tempData,
        bankPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "bankCode" &&
      showAutoCompleteList === true &&
      bankCode !== ""
    ) {
      this.readBankBySearchString(e.target.value);
      this.readBank(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ depositData: tempData });
  };
  bankEnterKeyEvent = (e) => {
    this.readBank(e.target.value);
    this.state.isShowAutoCompleteBankList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
    this.setState({
      bankPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayBankAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteBankList: isShowAutoCompleteList,
    });
  };
  readBankBySearchString = (searchString) => {
    let bankData = this.state.banks;
    let simpleAutoCompleteList = new Array();
    if (bankData.length > 0 && bankData != null) {
      bankData.map((obj) => {
        let bankBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(bankBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      bankPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readBank = (bankCode) => {
    let tempData = this.state.depositData;
    let bankBean = null;
    let bankData = null;
    this.state.banks.map((ln) => {
      if (ln.code === bankCode) {
        bankBean = ln;
        bankData = new BaseBean();
        bankData.code = ln.code;
        bankData.description = ln.description;
      }
    });
    if (!isEmpty(bankBean)) {
      tempData.bankCode = bankBean.code;
      this.state.isShowAutoCompleteBankList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteBankList;
      this.setState({
        depositData: tempData,
        isShowAutoCompleteBankList: showAutoCompleteList,
      });
    }
  };
  handleSortingSelectedPaymentChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingSelectedPayment(sortField, sortOrder);
    }
  };
  handleSortingSelectedPayment = (sortField, sortOrder) => {
    let list = this.state.selectedPayments;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ selectedPayments: sorted });
    }
  };
  handleSortingAvailablePaymentChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingAvailablePayment(sortField, sortOrder);
    }
  };
  handleSortingAvailablePayment = (sortField, sortOrder) => {
    let list = this.state.availablePayments;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ availablePayments: sorted });
    }
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.deposit_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ deposit_list: sorted });
    }
  };
  handleSortingStatusHistoryChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingStatusHistory(sortField, sortOrder);
  };
  handleSortingStatusHistory = (sortField, sortOrder) => {
    let list = this.state.statusTracks;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ statusTracks: sorted });
    }
  };
  listFormOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  filterDeposit = () => {
    this.loadPage(1);
  };
  resetDeposit = () => {
    let criteria = new DepositSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  openPaymentTypeForm = () => {
    this.setState({ isShowPaymentTypePopup: true });
  };
  addPaymentTypes = (e) => {
    if (e.detail === 1) {
      let selectedPayments = this.state.selectedPayments;
      let depositData = this.state.depositData;
      let overAllPaymentTypes = this.state.overAllPaymentTypes;
      let payments = "";
      let paymentsArray = [];
      let typeArray = [];
      selectedPayments.map((ln) => {
        payments = ln;
        paymentsArray.push(ln.description);
        typeArray.push(ln.code);
      });
      payments = paymentsArray.toString();
      overAllPaymentTypes = typeArray.toString();
      depositData.paymentTypes = payments;
      this.state.overAllPaymentTypes = overAllPaymentTypes;
      this.setState({
        depositData: depositData,
        overAllPaymentTypes: overAllPaymentTypes,
      });
      this.closeAlertModalCallBacklvl3(false);
    }
  };
  selectPaymentType = (e, value, rowData) => {
    if (e.detail === 1) {
      let availablePayments = this.state.availablePayments;
      let selectedPayments = this.state.selectedPayments;
      availablePayments.map((ln, i) => {
        if (ln.code === value) {
          selectedPayments.push(ln);
          availablePayments.splice(i, 1);
        }
      });
      this.setState({
        availablePayments: availablePayments,
        selectedPayments: selectedPayments,
      });
    }
  };
  unSelectPaymentType = (e, value, rowData) => {
    if (e.detail === 1) {
      let availablePayments = this.state.availablePayments;
      let selectedPayments = this.state.selectedPayments;
      selectedPayments.map((ln, i) => {
        if (ln.code === value) {
          availablePayments.push(ln);
          selectedPayments.splice(i, 1);
        }
      });
      this.setState({
        availablePayments: availablePayments,
        selectedPayments: selectedPayments,
      });
    }
  };
  unlockDeposit = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.DepositMaintenance_IsAccessible()) {
      AccountPayableService.unLockDepositNumber(
        request,
        this.unlockDepositResponse,
        this.unlockDepositError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockDepositResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editDeposit(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        this.showErrorMessage(response.data);
      }
    }
  };
  unlockDepositError = (error) => {
    ShowError("Error : ", error);
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  lnkCustomerModule = (code) => {
    let customerCode = code;
    if (customerCode !== "" && customerCode !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={customerCode}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  lnkARModule = (code) => {
    let arCode = code;
    if (arCode !== "" && arCode !== undefined) {
      this.setState({
        isShowARModule: true,
        moduleForPopup: (
          <PopupARModule code={arCode} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    isOpen = false;
    this.setState({
      isShowCustomerModule: isOpen,
      isShowARModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBacklvl3 = (isShowPopup) => {
    isShowPopup = false;
    this.setState({
      isShowPaymentTypePopup: isShowPopup,
      isShowAlertLvl3: isShowPopup,
    });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl3: isDisplayed });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  render() {
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={!this.state.isListFormOpen}
          onModuleKeyContainerButtonClick={this.editDeposit}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.depositLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {this.state.isEntryFormOpen && this.state.isViewMode == false && (
          <BaseToolBar
            extend_toolbar={
              <DepositToolBar
                isShowApproveButton={this.state.isShowApproveButton}
                approveDeposit={this.approveDeposit}
                isShowExcelButton={this.state.isShowExcelButton}
                generateExcel={this.generateExcel}
              />
            }
            save={this.save}
            clearError={this.clearError}
            generatePDF={this.generatePDF}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowApproveButton={this.state.isShowApproveButton}
            isShowPDFButton={this.state.isShowPDFReportButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={this.state.moduleOrderStatus}
          />
        )}

        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isHistoryFormOpened &&
          !this.state.isEntryFormOpen &&
          this.getHistoryView()}
        {this.state.isEntryFormOpen && (
          <DepositEntryForm
            {...this.state}
            onChange={this.onChange}
            fetchClick={this.fetchClick}
            onSelectedChange={this.onSelectedChange}
            calculateDepositAmount={this.calculateDepositAmount}
            generateExcel={this.generateExcel}
            selectAll={this.selectAll}
            unSelectAll={this.unSelectAll}
            openPaymentTypeForm={this.openPaymentTypeForm}
            bankOnChange={this.bankOnChange}
            bankEnterKeyEvent={this.bankEnterKeyEvent}
            displayBankAutoCompleteList={this.displayBankAutoCompleteList}
            lnkCustomerModule={this.lnkCustomerModule}
            lnkARModule={this.lnkARModule}
          />
        )}
        {this.state.isListFormOpen && (
          <DepositListForm
            {...this.state}
            editDeposit={this.editDeposit}
            handleSortingChange={this.handleSortingChange}
            filterDeposit={this.filterDeposit}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            resetDeposit={this.resetDeposit}
            listFormOnChange={this.listFormOnChange}
          />
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowPaymentTypePopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl3}
          title={"Payment Type Selection Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addPaymentTypes(e)}
                disabled={this.state.isDisableFields}
              >
                Add/Update
              </Button>
            </div>
          }
          content={
            <div>
              <div className="div_Custom_3">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th></th>
                      <th
                        onClick={(e) =>
                          this.handleSortingAvailablePaymentChange(e, "code")
                        }
                      >
                        PaymentType Code{" "}
                        {this.state.order === "desc" &&
                        this.state.sortField === "code" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingAvailablePaymentChange(
                            e,
                            "description"
                          )
                        }
                      >
                        PaymentType Description{" "}
                        {this.state.order === "desc" &&
                        this.state.sortField === "description" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {!isEmptyArray(this.state.availablePayments) && (
                    <tbody>
                      {this.state.availablePayments.map((ln, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              variant="secondry"
                              onClick={(e) =>
                                this.selectPaymentType(e, ln.code, ln)
                              }
                            >
                              <AddIcon />
                            </Button>
                          </td>
                          <td>{ln.code}</td>
                          <td>{ln.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
                {this.state.availablePayments.length != 0 ? null : (
                  <div className="no_Data_small">{"NO DATA"}</div>
                )}
              </div>
              <div className="div_Custom_3">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th></th>
                      <th
                        onClick={(e) =>
                          this.handleSortingSelectedPaymentChange(e, "code")
                        }
                      >
                        PaymentType Code{" "}
                        {this.state.order === "desc" &&
                        this.state.sortField === "code" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingSelectedPaymentChange(
                            e,
                            "description"
                          )
                        }
                      >
                        PaymentType Description{" "}
                        {this.state.order === "desc" &&
                        this.state.sortField === "description" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {!isEmptyArray(this.state.selectedPayments) && (
                    <tbody>
                      {this.state.selectedPayments.map((ln) => (
                        <tr>
                          <td>
                            <Button
                              variant="secondry"
                              onClick={(e) =>
                                this.unSelectPaymentType(e, ln.code, ln)
                              }
                            >
                              <CancelIcon />
                            </Button>
                          </td>
                          <td>{ln.code}</td>
                          <td>{ln.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
                {this.state.selectedPayments.length != 0 ? null : (
                  <div className="no_Data_small">{"NO DATA"}</div>
                )}
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
class DepositHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  handleSortingStatusHistoryChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingStatusHistoryChange(accessor);
  };
  render() {
    let statusTracks = this.props.statusTracks;
    return (
      <div className="header_div">
        <div className="div_Custom_3">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusHistoryChange(e, "createdDate")
                  }
                >
                  Date{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusHistoryChange(e, "currentStatus")
                  }
                >
                  Status{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "currentStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusHistoryChange(e, "previousStatus")
                  }
                >
                  PreviousStatus{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "previousStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusHistoryChange(e, "createdBy")
                  }
                >
                  DoneBy{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdBy" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {statusTracks != null ? (
              <tbody>
                {statusTracks.map((ln, index) => (
                  <tr key={index}>
                    <td>{ln.createdDate}</td>
                    <td>
                      {ModuleUtils.getDepositStatusCaption(ln.currentStatus)}
                    </td>
                    <td>
                      {ModuleUtils.getDepositStatusCaption(ln.previousStatus)}
                    </td>
                    <td>{ln.createdBy}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {statusTracks.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
function DepositModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <DepositList {...props} name="" /> <br />
    </div>
  );
}

export default DepositModule;
